<!--
  IGNTR sidebar — outer dark shell that wraps brand, search, items and user
  card. Behavioural wiring (menuclose, logout, unimpersonate, feature flags,
  isUploading, language sub) is untouched. The internal layout matches the
  handoff Angular shell at:
    .claude/igntr-handoff/ignrr-hf/angular-app/src/app/shared/sidebar.component.ts
-->
<div
  class="igntr-theme sidebar-dark flex h-full w-full flex-col bg-sidebar-bg text-white font-sans"
  [class.disableEvent]="isUploading"
  [class.nybolig-sidebar]="isNybolig"
>
  <!-- Mobile-only close affordance — full-width header bar with divider so
       it reads as the drawer's top edge, not a floating widget. -->
  <!-- <div
    class="flex items-center justify-between gap-2 border-b border-white/5
           px-4 py-3 text-[12px] text-white/55 lg:hidden"
  >
    <span class="font-mono uppercase tracking-[0.14em] text-white/40">
      {{ "closeMenu" | transloco }}
    </span>
    <button
      type="button"
      (click)="menuclose()"
      class="rounded p-1 text-white hover:bg-white/10"
      aria-label="Close menu"
    >
      <i class="bi bi-x text-[22px] leading-none"></i>
    </button>
  </div> -->

  <!-- Brand — centered when a tenant custom logo is shown, left-aligned for
       the default IGNTR mark and Nybolig. -->
  <div
    class="flex items-center gap-2 px-4 pt-4 pb-3"
    [class.justify-center]="customLogoUrl && !isNybolig"
  >
    <img
      *ngIf="isNybolig"
      src="https://igntrstorages.blob.core.windows.net/media-library/data-room/8fa1d45f-a881-40e5-9477-08dc7d94ec51/c3e7f1f3-fcb5-40bf-af58-5bf7309b080c_Nybolig_Logo_Hvid.png"
      alt="Nybolig"
      class="h-8 w-auto"
    />
    <ng-container *ngIf="!isNybolig">
      <!-- Tenant custom logo (Information tab) takes precedence over the
           default IGNTR mark when one is configured. -->
      <img
        *ngIf="customLogoUrl; else igntrBrand"
        [src]="customLogoUrl"
        [alt]="activeTenantLabel"
        class="h-8 w-auto"
      />
      <ng-template #igntrBrand>
        <igntr-flame [size]="22"></igntr-flame>
        <span class="text-[15px] font-semibold tracking-[0.18em]">IGNTR</span>
      </ng-template>
    </ng-container>
  </div>

  <!-- Search — hidden for now. Filters the nav items below in real time.
       SidebarState is shared with <app-sidebar-items>, which reads
       `searchQuery` to drop non-matching rows + auto-expand sections that
       contain matches.
  <label
    class="mx-3 mb-3 flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2 text-[12.5px] text-white/50 transition focus-within:bg-white/10 hover:bg-white/10"
  >
    <igntr-icon name="search" [size]="14"></igntr-icon>
    <input
      type="text"
      name="sidebarSearch"
      [(ngModel)]="sidebarState.searchQuery"
      placeholder="Søg eller hop til…"
      class="min-w-0 flex-1 bg-transparent text-white placeholder:text-white/50 focus:outline-none"
    />
    <kbd class="rounded bg-white/10 px-1.5 py-0.5 font-mono text-[10px] text-white/70">⌘K</kbd>
  </label>
  -->
  <div class="pt-1"></div>

  <!-- Nav -->
  <!-- `sidebar-nav-pad` knocks nav side-padding from 8px to 2px below lg,
       so item hover/active highlights take up more of the drawer width
       on mobile. Desktop keeps the original 8px inset. -->
  <nav class="sidebar-nav-pad w-full flex-1 overflow-y-auto pb-3">
    <app-sidebar-items></app-sidebar-items>
  </nav>

  <!-- Active tenant chip (pinned above the user card so it stays visible
       even when the nav list is long enough to scroll). The avatar is
       absolutely positioned over the left padding of <app-datalist-select>;
       `[clearable]="false"` removes the X. -->
  <div
    *ngIf="tenantsOptions && tenantsOptions.length > 1"
    class="w-full px-3 pt-2 pb-2"
  >
    <div
      class="mb-1.5 px-1 font-mono text-[10px] uppercase tracking-[0.14em] text-white/40"
    >
      {{ "activeTenant" | transloco }}
    </div>
    <div
      class="igntr-tenant-select relative block w-full rounded-lg border border-white/10 bg-white/5"
    >
      <!-- Outer span fills the full vertical area of the chip and uses flex
           to center the avatar — avoids Tailwind transform utilities which
           don't work with preflight disabled. Inline `style` attribute
           with backticks for the gradient (Angular template literal). -->
      <span
        aria-hidden="true"
        class="pointer-events-none absolute inset-y-0 left-2 z-10 flex items-center"
      >
        <span
          class="flex h-6 w-6 items-center justify-center rounded-md text-[11px] font-semibold text-white"
          [attr.style]="'background: ' + activeTenantAvatarBg"
        >
          {{ activeTenantInitial }}
        </span>
      </span>
      <app-datalist-select
        [activeValue]="tenantId"
        [options]="tenantsOptions"
        [clearable]="false"
        (activeValueChange)="setActiveTenant($event)"
        [multiple]="false"
      ></app-datalist-select>
    </div>
  </div>

  <!-- User -->
  <app-menuuser-card class="block border-t border-white/5"></app-menuuser-card>
</div>
